import axios from "axios";
import { store } from "../app/store";
import { setAuthenticated, setBuyer } from "../redux/slices/authSlice";

// Resolve API base URL adapting to Android Emulator (10.0.2.2) when needed
const resolveBaseURL = () => {
  const envBase = process.env.REACT_APP_API_URL;
  if (!envBase) {
    if (process.env.NODE_ENV !== "production") {
      return "http://localhost:3001";
    }
    throw new Error("REACT_APP_API_URL is required in production builds.");
  }

  try {
    const url = new URL(envBase);
    // If env points to localhost but the app is served from a different host (e.g., 10.0.2.2 in Android WebView),
    // align the API hostname to the current page's hostname to keep both on the same machine.
    if (typeof window !== "undefined" && window.location) {
      const currentHost = window.location.hostname; // e.g., 10.0.2.2 when accessed via Android emulator
      if (
        url.hostname === "localhost" &&
        currentHost &&
        currentHost !== "localhost"
      ) {
        url.hostname = currentHost;
        return url.toString();
      }
    }

    return envBase;
  } catch (e) {
    // Fallback to env if URL parsing fails
    return envBase;
  }
};

const api = axios.create({
  baseURL: resolveBaseURL(),
  headers: { "Content-Type": "application/json" },
});

// Add a request interceptor to add the JWT token to headers, if available.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("jwtToken");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

// Global response interceptor to handle expired or invalid tokens
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = String(error?.config?.url || "");
    const isAuthFlowRequest = /\/buyer\/(auth\/(login|register|check-phone|check-email-status|forgot-password|reset-password)|otp\/)/.test(url);

    if (status === 401 && !isAuthFlowRequest) {
      localStorage.removeItem("jwtToken");
      localStorage.removeItem("buyer");
      store.dispatch(setAuthenticated(false));
      store.dispatch(setBuyer(null));
      window.location.href = "/auth/sign-in";
    } else if (status === 429) {
      if (typeof window !== "undefined" && window.location?.pathname !== "/error/429") {
        window.location.href = "/error/429";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
